import isset from './isset';

/**
 * Retourne les données correspondant aux clés avec la profondeur
 * @param {Object} data Données à filtrés
 * @param {Array} keys Clés à conserver
 * @returns {*}
 */
export default function filterData (data, keys) {
  if (isset(data)) {
    let result = {};
    keys.forEach(key => {
      if (key instanceof Array) {
        let deepKey = key[0].split('.');
        if (isset(data[deepKey[0]])) {
          result[key[1]] = deepKey.reduce((obj, key) => {
            // Si obj n'existe pas, test la propriété dans le data
            if (obj === undefined && isset(data[key])) {
              return data[key];
            } else if (obj !== undefined && isset(obj[key])) { // Si un Object existe, test la propriété enfant
              return obj[key];
            }
            return obj;
          }, undefined);
        }
      } else if (isset(data[key])) {
        result[key] = data[key];
      }
    });
    return result;
  }
  return {};
}
